# Allows you to negate the value in the view from the model
# eg. model = -5, view = 5
angular.module('rjmNg.directives').directive 'negation', [() ->
  require: 'ngModel'
  link: (scope, elem, attrs, ngModel) ->

    ngModel.$parsers.push (viewVal) ->
      if viewVal?
        viewVal *= -1
      return viewVal

    ngModel.$formatters.unshift (modelVal) ->
      if modelVal?
        modelVal *= -1
      return modelVal
]
